import React from 'react';
import { Typography, Stack, Box, Button, useMediaQuery, TextField, InputAdornment } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ClientButton from './Clientbutton';
import { useClient } from '../../../context/ClientContext';
import StepsHeading from './StepsHeading';
import CommonErrorMessage from './CommonErrorMessage';

export const ClientInputField = ({
    userData,
    setUserData,

    // Core props
    title,
    extraText,
    btnTitle,
    skipBtnTitle,
    onClickNext,
    onClickSkip,

    // Input field
    placeholder,
    minRowsCount = 1,
    value,
    onChange,
    onKeyDown,
    onAddBtnClick,
    isAddButtonInUI = false,

    // Suggestions
    inputValue,
    filteredOptions,
    handleSuggestedOptionSelect,

    // User selected list
    answerArray,
    onCloseIconClickInOptionArrayList,

    // Field identifiers
    field,
    isFieldError,
}) => {
    const isSmallHeight = useMediaQuery('(max-height:700px)');
    const { theme } = useClient();

    const isLargeScreen = useMediaQuery('(min-width:600px)');

    const preventScrollPropagation = (e) => {
        const container = e.currentTarget;
        const isAtTop = container.scrollTop === 0;
        const isAtBottom = container.scrollHeight - container.scrollTop === container.clientHeight;
    
        if ((isAtTop && e.deltaY < 0) || (isAtBottom && e.deltaY > 0)) {
            e.preventDefault();
            e.stopPropagation();
        }
    };
    return (
        <Stack
            sx={{
                width: '100%',
                maxWidth: '100%',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            {/* <Typography
                sx={{
                    fontSize: { xs: '20px', sm: '23px', md: '26px' },
                    fontWeight: "700",
                    lineHeight: { xs: '24px', sm: '27px', md: '32px' },
                    textAlign: "center",
                    px: { xs: 1, sm: 4 },
                    width: '100%',
                    paddingTop: { xs: "10px", sm: 1 },
                    marginBottom: "10px"
                }}
            >
                {title}
            </Typography> */}
            <StepsHeading title={title} />
            {extraText && (
                <Typography
                    color="#000"
                    sx={{
                        fontSize: "14px",
                        fontWeight: 400,
                        lineHeight: "18px",
                        textAlign: "center",
                        color: "#000",

                    }}
                >
                    {extraText}
                </Typography>
            )}

            <Box position="relative">
                <Box sx={{ width: '100%', my: '10px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: "center", position: "relative" }}>
                    <TextField
                        autoComplete="off"
                        fullWidth
                        minRows={minRowsCount}
                        value={value}
                        onChange={onChange}
                        onKeyDown={onKeyDown}
                        placeholder={placeholder}
                        sx={{
                            width: { xs: '300px', sm: '360px', md: '400px' },
                            mt: { xs: 1, md: "10px", lg: "14px" },
                            backgroundColor: theme.inputFieldCSS.inputfiledBgColor,
                            borderRadius: theme.inputFieldCSS.inputfiledBorderRadious || "10px",
                            '& .MuiOutlinedInput-root': {
                                backgroundColor: theme.inputFieldCSS.inputfiledBgColorOnFocus,
                                transition: 'all 0.2s ease-in-out',
                                '& fieldset': { border: 'none' },
                                '&.Mui-focused fieldset': {
                                    border: theme.inputFieldCSS.inputFieldBorderOnFocus,
                                    borderRadius: theme.inputFieldCSS.inputfiledBorderRadious || "10px",
                                },
                            },
                            '& .MuiInputBase-input': {
                                color: theme.inputFieldCSS.inputfiledTextColor,
                                fontSize: { xs: '16px', sm: '19px' },
                                fontWeight: 500,
                                padding: '16px 14px',
                            },
                            '& ::placeholder': {
                                color: theme.inputFieldCSS.inputFieldPlaceholderColor,
                                opacity: 1,
                                fontWeight: 500,
                            },
                        }}
                        InputProps={{
                            endAdornment: isAddButtonInUI && (
                                <InputAdornment position="end">
                                    <Box
                                        onClick={onAddBtnClick}
                                        sx={{ cursor: 'pointer', px: 1 }}
                                    >
                                        <Typography
                                            sx={{
                                                fontSize: '14px',
                                                fontWeight: 500,
                                                color: theme.inputFieldCSS.inpuFieldAddBtnTextColor || '#000',
                                            }}
                                        >
                                            Add +
                                        </Typography>
                                    </Box>
                                </InputAdornment>
                            ),
                        }}
                    />
                </Box>

                {/* show Erro below text field */}
                {isFieldError && (

                    <Box sx={{ marginTop: isLargeScreen ? "8px" : "50px" , display : "flex", justifyContent : "start"}}>
                        <CommonErrorMessage
                            text={isFieldError}
                        />
                    </Box>
                )}

                {/* list of suggested options from procide data list container */}
                {filteredOptions?.length > 0 && inputValue && (
                    <Stack
                       onWheel={preventScrollPropagation}
                        sx={{
                            position: "absolute",
                            top: '100%',
                            left: 0,
                            zIndex: 200,
                            height: '200px',
                            overflowY: 'scroll',
                            border: '1px solid #ccc',
                            borderRadius: '8px',
                            padding: '8px',
                            backgroundColor: '#fff',
                            width: {
                                xs: '300px',
                                sm: '360px',
                                md: '400px',
                            },
                        }}
                    >
                        {filteredOptions.map((option, index) => (
                            <Box
                                key={index}
                                onClick={() => handleSuggestedOptionSelect(field, option)}
                                sx={{
                                    color: theme.inputFieldCSS.inpuFieldSuggestedListOptionTextColor,
                                    '&:hover': {
                                        backgroundColor: theme.inputFieldCSS.inpuFieldSuggestedListHoverOnOptionBgColor,
                                        color: theme.inputFieldCSS.inpuFieldSuggestedListHoverOnOptionTextColor,
                                    },
                                    padding: '8px 4px',
                                    cursor: 'pointer',
                                    width: {
                                        xs: '300px',
                                        sm: '360px',
                                        md: '400px',
                                    },
                                    boxSizing: "border-box",
                                }}
                            >
                                <Typography fontWeight="500" fontSize="14px" lineHeight="18px">
                                    {option}
                                </Typography>
                            </Box>
                        ))}
                    </Stack>
                )}
            </Box>


            {/* added options chip UI  */}
            <Stack
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'start',
                    alignItems: 'start',
                    padding: "0px 8px",
                    boxSizing: "border-box",
                    flexWrap: "wrap",
                    marginTop: "20px",
                    overflowY: "scroll",
                    overscrollBehavior: 'contain', // make sure dont trigger vieport scroll 
                    WebkitOverflowScrolling: 'touch',
                    width: {
                        xs: '100%',
                        sm: '360px',
                        md: '400px',
                    },
                    maxHeight: {
                        lg: "130px",
                        md: "120px",
                        xs: isSmallHeight ? "100px" : "200px"
                    },
                    minHeight : "100px"
                }}
            >
                {answerArray?.length > 0 ? (
                    answerArray.map((option, index) => (
                        <Box
                            key={index}
                            sx={{
                                borderRadius: "28px",
                                backgroundColor: theme.inputFieldCSS.inputFieldAnswerPillsBGColor,
                                color: theme.inputFieldCSS.inputFieldAnswerPillsTextColor,
                                display: "flex",
                                alignItems: "center",
                                padding: "14px 20px",
                                marginRight: "10px",
                                marginBottom: "10px",
                                minWidth: "105px",
                                minHeight: "36px",
                                boxSizing: "border-box",
                            }}
                        >
                            <Typography
                                sx={{
                                    wordBreak: "break-word",
                                    fontWeight: "500",
                                    fontSize: "12px",
                                    lineHeight: "18px",
                                }}
                            >
                                {option}
                            </Typography>
                            <Box
                                onClick={() => onCloseIconClickInOptionArrayList(option, field)}
                                sx={{
                                    padding: "0px 4px 0px 10px",
                                    cursor: "pointer",
                                    color: theme.inputFieldCSS.removeIconColor
                                }}
                            >
                                <CloseIcon fontSize="10px" />
                            </Box>
                        </Box>
                    ))
                ) : (
                    // This ensures spacing even if empty
                    <Box sx={{ flex: "1 0 100%" }} />
                )}
            </Stack>






            <Box sx={{ marginTop: { lg: "50px", xs: 1, sm: 3 }, width: "100%", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }} >
                <ClientButton
                    text="Next"
                    onClick={onClickNext}
                    backgroundColor={theme.primaryColor}
                    sx={{ maxWidth: "320px", width: "100%" }}
                />
                <Button
                    onClick={onClickSkip}
                    sx={{
                        mt: { xs: '4px', sm: '10px', md: '12px', lg: '16px' },
                        color: "#A1A0A0",
                        fontSize: { xs: '15px', sm: '17px' },
                        fontWeight: "600",
                        '&:hover': {
                            color: '#ee5c36',
                            backgroundColor: 'transparent'
                        }
                    }}
                >
                    {skipBtnTitle}
                </Button>
            </Box>
        </Stack>
    );
};


